import React from 'react'
import { ClientSettings, PreviewMenu } from '@types'
import UniversalMenuExplorer from '@containers/groupOrders/UniversalMenuExplorer/UniversalMenuExplorer'
import { MenuConcept } from './types'

interface UniversalMenuSelectorProps {
  date: moment.Moment
  clientSettings: ClientSettings
  stagedMenus: MenuConcept[]
  onSelectMenu: (m: PreviewMenu, excludedItemIds: Set<string>) => void
}

export const UniversalMenuSelector: React.FC<UniversalMenuSelectorProps> = ({
  date,
  clientSettings,
  stagedMenus,
  onSelectMenu,
}) => {
  return (
    <div className="w-full h-full pt-4">
      <UniversalMenuExplorer
        initialDayOfWeek={date.isoWeekday()}
        initialClientSettings={clientSettings}
        stagedMenus={stagedMenus}
        mode="apply"
        selectMenu={onSelectMenu}
      />
    </div>
  )
}
